import { reportShipmentsReturnsTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_SHIPMENTS_RETURNS_FILTERS,
  RESTORE_INITIAL
} = reportShipmentsReturnsTypes;

const getInitialState = () => ({
  startDate: newDate(),
  endDate: newDate(),
  station: null,
});

export const reportShipmentsReturnsReducer = (state = getInitialState(), { type, payload }) => {
  switch (type) {
    case SET_SHIPMENTS_RETURNS_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return getInitialState();

    default:
      return state;
  }
};
